<template>
  <!-- 增加修改页面 -->
  <div class="_dialog">
    <div class="_top">
      <i @click="close" style="cursor: pointer;" class="el-icon-d-arrow-left"></i>
      <span @click="close">{{ $t('StorageGoods.back') }}</span>
      <div style="width: 1px;height: 20px;background-color:#e5e6eb;"></div>
      <font>{{ AllotTitle }}</font>
    </div>
    <div style="height: calc(100vh - 290px);overflow-y: auto;">
      <el-form ref="form" label-position="left" :rules="rules" label-width="100px" input-width="100px"
        :model="StorageAllotDan">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('StorageAllot.OutWarehouseName')" prop="OutWarehouseName">
              <el-input :placeholder="$t('StorageOutKu.choice')" v-model="StorageAllotDan.OutWarehouseName"
                @input="changeDraft($event, 'OutWarehouseName', 0)" readonly class="input-with-select">
                <el-button slot="append" icon="el-icon-thumb" @click="RoomClick(StorageAllotDan)"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"><!-- 接收库房 -->
            <el-form-item :label="$t('StorageAllot.InWarehouseName')" prop="InWarehouseName">
              <el-input :placeholder="$t('StorageOutKu.choice')" v-model="StorageAllotDan.InWarehouseName"
                @input="changeDraft($event, 'InWarehouseName', 0)" readonly class="input-with-select">
                <el-button slot="append" icon="el-icon-thumb" @click="InRoomClick(StorageAllotDan)"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('StorageAllot.OutAllotTime')">
              <el-date-picker v-model="StorageAllotDan.OutAllotTime" @change="changeDraft($event, 'AllotTime', 0)"
                type="datetime" :clearable="false" :placeholder="$t('AssetHandOverAdd.tips2')" style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('StorageAllot.OutAllotRemark')" v-if="allShow == false"> <!-- 调出描述 -->
              <el-input :readonly="allShow" maxlength="512" show-word-limit type="textarea" class="textarea" rows="2"
                v-model="StorageAllotDan.OutAllotRemark" @input="changeDraft($event, 'OutAllotRemark', 0)"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="_filter">
        <div v-show="!allShow">
          <el-divider></el-divider>
          <el-button icon="el-icon-plus" class="button_primary" :disabled="StorageAllotDan.OutWarehouseName == ''"
            @click="AddGoods()">{{
              $t('StorageAllot.SelectGoods') }}</el-button><!-- 选择物资 -->
          <el-button class="button_info" icon="el-icon-delete" @click="DelGoods()" :disabled="goodsChecked">{{
            $t('StorageAllot.DeleteGoods')
          }}</el-button> <!-- 删除所选 -->
          <el-button class="button_info" icon="el-icon-edit" @click="AddBatch()">{{ $t('StorageAllot.BatchInput')
          }}</el-button> <!-- 批量输入 -->
          <el-input v-model="batchNumber" v-if="BatchInku" type="number" :placeholder="$t('StorageInKu.BatchInputNews')"
            @input="BatchInput" style="width: 240px !important;margin-left: 10px;"></el-input>
          <span class="Refresh"><i class="el-icon-setting" @click="TableOk = true" style="color:#165dff;cursor: pointer;">
              {{ $t('BasicDept.CustomizeHeader') }}</i> </span> <!--自定义表头-->
        </div>
      </div>
      <div style="position: relative;width: 100%;height: calc(100vh - 600px);">
        <el-table :key="itemKey" v-loading="loading" style="position: absolute;" border :data="AllotNotes" width="88%"
          height="calc(100vh - 600px)" stripe @selection-change="handleSelectionChange1" ref="dialogList"
          :row-class-name="selectRowClassName1" @row-click="handleRowClick1" @header-dragend="headerDragend">
          <el-table-column v-if="!allShow" type="selection" width="55">
          </el-table-column>
          <el-table-column :sortable="item.sort" v-for="(item, index) in GoodsTable" :key="index" :prop="item.propName"
            :label="item.labelName" :width="item.width">
            <template slot-scope="scope">
              <ImageView v-if="item.propName == 'HuoPinImage'" :url="scope.row.GoodsImage || scope.row.HuoPinImage">
              </ImageView>
              <el-input v-else-if="item.propName == 'AllotCount'" type="number" oninput="value=value.replace(/[^\d]/g,'')"
                class="_table_input" v-model="scope.row.AllotCount" :data-rowindex="'AllotCount' + scope.$index"
                :ref="`inputRef${scope.$index + 1}`" @keydown.tab.native="focusTabInput(scope.$index + 1)"
                @keyup.enter.native="focusTabInput(scope.$index + 1, 'AllotCount')"></el-input>
              <span v-else>
                {{ scope.row[item.propName] }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="but_add">
      <div>
        <span> {{ $t('StorageAllot.Count') }}{{ AllotKuNumber }} {{ $t('StorageAllot.SumMoney') }}{{ AllotAllPrice }}
        </span>
      </div>
      <div>
        <el-button @click="close" class="button_info" style="margin-right: 7px">{{ $t('StorageOutKu.cancel')
        }}</el-button>
        <el-button :loading="$store.getters.Loading" type="primary" class="button_primary" @click="append()">{{
          $t('StorageOutKu.confirm') }}</el-button>
      </div>
    </div>

    <!-- 调出库房 -->
    <SelectWarehouse v-if="Roomtype" :type="Roomtype" @close="Roomtype = false" @addMember="addRoom" :DataList="RoomList">
    </SelectWarehouse>
    <!-- 调入库房 -->
    <SelectWarehouse v-if="InRoomtype" :type="InRoomtype" @close="InRoomtype = false" @addMember="InAddRoom"
      :DataList="InRoomList"></SelectWarehouse>
    <!-- 物资组件 -->
    <SystemGoods v-if="gooodsType" :type="gooodsType" :warehouseid="StorageAllotDan.OutWarehouseID" :DataList="DataList"
      @close="gooodsType = false" @addGoods="addGoods">
    </SystemGoods>
    <ExportView v-if="upload" :state="upload" :uptype="uptype" :exportColumn="exportColumn" :error="errString"
      :errUrl="errUrl" :importUrl="`TemplateName=${viewtype}`" @close="upload = false"
      @clean="errString = '', errUrl = ''" @submit="ExportInput"></ExportView>
    <DragTable v-if="TableOk" TableName="StorageAllotAdd" :show="TableOk" @message="Message_">
    </DragTable>
    <!-- 审批人自选组件 -->
    <ApproveSteps v-if="ApproveShow" :show="ApproveState" :ApprovalList="ApprovalList" @close="ApproveShow = false"
      @submit="SetApproveKeys">
    </ApproveSteps>
  </div>
</template>
  
<script>
import mixins from "@/mixins/index";
import {
  msgTips,
  successTips,
  getAllotDanStatus,
  GetStorageWarehouseTree,
  getAllotDetail,
  addAllotDan,
  updateAllotDan,
  updateTime,
  GetExportColumn,
  SetBasicUserColumnWidth,
  GetExportDownUrl,
  LoadBasicUserColumn,
  ImportData,
  GetStorageShelfPage
} from "@/api/user";
import draft from '@/mixins/draft';
import approve from "@/mixins/approve";
export default {
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  props: {
    AllotOpertion: {
      type: Object
    },
    show: {
      type: Boolean,
    },
    AllotID: {
      type: Number,
      default: 0
    },
    AllotTitle: {
      type: String,
      default: ''
    },
    state: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  name: "SettingView",
  components: {},
  mixins: [mixins, draft, approve],
  data() {
    return {
      menutab: 0,
      Roomtype: false,
      InRoomtype: false,
      RoomList: [],
      GoodsTable: [],
      TableOk: false,
      InRoomList: [],
      queryState: false,
      operated: true,
      delstate: false,
      checkstate: false,
      ID: "",
      level: "",
      allShow: false,
      addType: true,
      drawer: false,
      filterText: "",
      icon: "",
      AllotCount: "",
      title: "",
      currentPage: 1,
      fileList: "",
      Title: "",
      gooodsType: false,
      checked: true,
      BatchInku: false,
      goodsChecked: true,
      shows: false,
      tableData: [],
      AllotNotes: [],
      DataList: [],
      TotalCount: 0,
      warehouseid: "",
      StorageAllotDan: {
        AllotDanCode: "",
        OutWarehouseID: "",
        OutWarehouseName: "",
        OutAllotRemark: "",
        InWarehouseID: "",
        OutAllotTime: new Date(),
        InWarehouseName: "",
        InAllotRemark: "",
        OutKuStatus: "",
        OutKuRemark: "",
        AllotDanID: "",
        OutKuShelfID: '',
        InKuShelfID: '',
        AllotTime: new Date()
      },
      OperateType: "",
      data: [],
      warehouse: [],
      value: "",
      value1: "",
      value2: "",
      NotesID: "",
      receivedNum: 1,
      disreceive: true,
      loading: false,
      Times: null,
      options: [
        {
          label: this.$t('StorageAllot.unknown'),
          value: 0,
        },
        {
          label: this.$t('StorageAllot.confirm'),
          value: 1,
        },
        {
          label: this.$t('StorageAllot.Reject'),
          value: 2,
        },
        {
          label: this.$t('StorageAllot.delete'),
          value: 3,
        },
        {
          label: this.$t('StorageAllot.outline'),
          value: 4,
        },
        {
          label: this.$t('StorageAllot.Receive'),
          value: 5,
        },
        {
          label: this.$t('StorageAllot.Refusal'),
          value: 6,
        },
      ],
      rules: {
        OutWarehouseName: [
          { required: true, message: this.$t('StorageAllot.choice'), trigger: "blur" },
        ],
        InWarehouseName: [
          { required: true, message: this.$t('StorageAllot.choice'), trigger: "blur" },
        ],
      },
      multipleSelection: [],
      multipleSelection1: [],
      upload: false,
      uptype: '',
      allotID: '',
      exportColumn: [],
      selectTable: [],
      lin_Data: [],
      ExportType: '',
      errString: "",
      itemKey: '',
      errUrl: '',
      showdetail: false,
      viewtype: '',
      draftTitle: ['StorageAllotDan'],
      batchNumber: null,
      Outoptions: [],
      Inoptions: [],
      ApproveShow: false
    };
  },
  computed: {
    AllotKuNumber() {
      let sum = 0;
      for (let item of this.AllotNotes) {
        sum += parseInt(item.AllotCount || 0);
      }
      return sum;
    },
    AllotAllPrice() {
      let sum = 0;
      let price;
      for (let item of this.AllotNotes) {
        price = parseFloat(item.AllotCount * item.DefaultPrice).toFixed(2);
        sum += parseFloat(price);
      }
      if (price == 'NaN') {
        sum = 0;
      }
      return sum;
    },
  },
  mounted() {
    this.getWarehouseTree();
    this.getStatus();
    this.getTableColumn();
    if (this.AllotOpertion.Opertion == 'Update') {
      this.loading = true;
      getAllotDetail({ AllotDanID: this.AllotID }).then(
        (res) => {
          if (res.Code == 0) {
            this.StorageAllotDan = res.Data;
            this.StorageAllotDan.OutAllotTime = updateTime(this.StorageAllotDan.OutAllotTime);
            this.AllotNotes = res.Data.DetailList;
            this.addType = false;
            this.loading = false;
          }
        }
      );
    }

    if (this.state) {
      this.loading = true;
      this.StorageAllotDan = JSON.parse(window.localStorage.getItem(this.draftTitle[this.draftIndex]));
      this.getShelf('in');
      this.getShelf('out');
      setTimeout(() => {
        this.AllotNotes = JSON.parse(window.localStorage.getItem('StorageAllotNotes')) || [];
        this.loading = false;
      }, 1000)
    }
    document.addEventListener('keydown', this.keyprevent);
    this.shows = this.show;
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyprevent)
  },
  created() {
    // 当页面刷新时，若本地存储中存的有表头数组信息，就用本地的。当然第一次本地是没有的
    if (sessionStorage.getItem("AllotTable")) {
      this.AllotTable = JSON.parse(sessionStorage.getItem("AllotTable"));
    }
  },
  methods: {
    SetApprove(i, e) {
      console.log(this.ApproveKeys[i]);
      console.log(i, e);
    },
    // 表头拖动事件
    headerDragend(newWidth, data, e) {
      data
      if (e.property != null) {
        SetBasicUserColumnWidth({ TableKey: 'StorageAllotAdd', ColumnKey: e.property, Width: newWidth }).then(res => {
          if (res.Code == 0) {
            res
          }
        })
      }
    },
    // 表单加载
    getTableColumn() {
      LoadBasicUserColumn({ TableKey: 'StorageAllotAdd' }).then(res => {
        if (res.Code == 0) {
          this.GoodsTable = res.Data;
        }
      })
    },
    //刷新
    Message_() {
      this.lin_Data = this.AllotNotes;
      this.AllotNotes = this.lin_Data;
      this.getTableColumn();
      this.itemKey = Math.random();
      this.TableOk = false;
    },
    addRoom(e) {
      this.StorageAllotDan.OutWarehouseID = e.WarehouseID;
      this.StorageAllotDan.OutWarehouseName = e.WarehouseName;
      this.changeDraft(e.WarehouseID, 'OutWarehouseID', 0);
      this.changeDraft(e.WarehouseName, 'OutWarehouseName', 0);
      this.$refs['form'].clearValidate(['OutWarehouseName']);  //移除表单某个字段的校验 
      this.Roomtype = false;
    },
    //出库点击事件
    RoomClick(data) {
      this.RoomList = [];
      if (data) {
        this.Roomtype = true;
        this.RoomList.push(data.OutWarehouseID);
      }
    },
    InAddRoom(e) {
      this.StorageAllotDan.InWarehouseID = e.WarehouseID;
      this.StorageAllotDan.InWarehouseName = e.WarehouseName;
      this.changeDraft(e.WarehouseID, 'InWarehouseID', 0);
      this.changeDraft(e.WarehouseName, 'InWarehouseName', 0);
      this.$refs['form'].clearValidate(['InWarehouseName']);  //移除表单某个字段的校验 
      this.InRoomtype = false;
    },

    //入库点击事件
    InRoomClick(data) {
      this.InRoomList = [];
      if (data) {
        this.InRoomtype = true;
        this.InRoomList.push(data.InWarehouseID);
      }
    },
    getShelf(type) {
      let form = {
        PageIndex: 0,
        PageSize: 100,
        WarehouseID: type == 'in' ? this.StorageAllotDan.InWarehouseID : this.StorageAllotDan.OutWarehouseID
      }
      GetStorageShelfPage(form).then(res => {
        if (res.Code == 0) {
          if (type == 'in') {
            this.Inoptions = res.Data;
          } else {
            this.Outoptions = res.Data;
          }
        }
      })
    },
    keyprevent(event) {
      if (event.keyCode === 9) {
        event.preventDefault()
      }
    },
    getColumn() {
      GetExportColumn({ ExportName: this.viewtype }).then(res => {
        if (res.Code == 0) {
          this.exportColumn = res.Data;
          this.upload = true;
        }
      })
    },
    ExportInput(value, state) {
      if (state == 'in') {
        let Url = value.upUrl
        ImportData({ Url, ImportName: this.viewtype }).then(res => {
          if (res.Code == 0) {
            this.errString = '';
            this.errUrl = '';
            successTips(res.Message)
          } else if (res.Code == 2) {
            this.errString = res.Message;
            this.errUrl = res.Data;
          }
        })
        this.upload = false;
      } else {
        let { ExportType } = value;
        let Head = JSON.stringify(value.Head)
        let SearchJson = JSON.stringify(this.form);
        GetExportDownUrl({ Head, ExportType, SearchJson, ExportName: this.viewtype }).then(res => {
          if (res.Code == 0) {
            let a = document.createElement('a');
            a.href = res.Data;
            this.upload = false;
            a.click();
            document.removeChild(a)
          }
        })
      }
    },

    //清空表格数据
    close() {
      this.draftState[this.draftIndex] = false;
      if (this.AllotNotes.length != 0) {
        window.localStorage.setItem('StorageAllotNotes', JSON.stringify(this.AllotNotes))
      }
      this.$emit("close");
    },
    checkOutCount(i, e) {
      if (parseInt(e) > this.AllotNotes[i].FactStock) {
        this.AllotNotes[i].AllotCount = this.AllotNotes[i].FactStock;
      } else {
        this.AllotNotes[i].AllotCount = parseInt(e);
      }
    },
    focusTabInput(rowIndex) {
      this.$nextTick(() => {
        this.$refs.dialogList.clearSelection();
        if (rowIndex < this.AllotNotes.length) {
          this.$refs[`inputRef${parseInt(rowIndex + 1)}`][0].focus();
          this.$refs.dialogList.toggleRowSelection(this.AllotNotes[rowIndex]);
        } else {
          this.$refs[`inputRef1`][0].focus();
          this.$refs.dialogList.toggleRowSelection(this.AllotNotes[0]);
        }
      })
    },
    //获取库房下拉树
    getWarehouseTree() {
      GetStorageWarehouseTree().then((res) => {
        if (res.Code == 0) {
          this.warehouse = res.Data;
        }
      });
    },
    //批量填充
    AddBatch() {
      if (this.BatchInku == false) {
        this.BatchInku = true;
      } else {
        this.BatchInku = false;
      }
    },
    // getTimeArr() {
    //   getTimeRange().then((res) => {
    //     if (res.Code == 0) {
    //       this.Times = res.Data;
    //       this.form.StartTime = res.Data[0];
    //       this.form.EndTime = res.Data[1];
    //     }
    //   });
    // },
    getStatus() {
      getAllotDanStatus().then((res) => {
        if (res.Code == 0) {
          if (res.Data) {
            this.options = [];
            for (let item of res.Data) {
              this.options.push({
                label: item.name,
                value: item.value,
              });
            }
          }
        }
      });
    },
    selStatus(e) {
      this.form.OutKuStatus = e;
      for (let item of this.options) {
        if (item.value == e) {
          this.form.AllotStatusName = item.label;
        }
      }
    },

    //重置
    SelectRemove() {
      for (let i in this.form) {
        this.form[i] = "";
      }
      this.form.PageIndex = 0;
      this.form.PageSize = 20;
    },


    // 选择资产
    async addGoods(e) {
      for (let i = 0; i < e.length; i++) {
        this.AllotNotes.push(e[i]);
      }
      let arr1 = this.unique(this.AllotNotes);
      this.AllotNotes = [];
      this.AllotNotes = arr1;
      window.localStorage.setItem('StorageAllotNotes', JSON.stringify(e));
      this.gooodsType = false;
    },
    //去重
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.GoodsID) && res.set(arr.GoodsID, 1));
    },
    //增加资产
    AddGoods() {
      this.DataList = [];
      if (this.AllotNotes != null) {
        for (let i = 0; i < this.AllotNotes.length; i++) {
          this.DataList.push(this.AllotNotes[i].GoodsID);
        }
      }
      this.gooodsType = true;
    },
    SetOutWarehouse(e) {
      this.changeDraft(e.label, 'OutWarehouseName', 0);
      if (!e) {
        this.StorageAllotDan.OutWarehouseID = "";
        return;
      }

      this.addType = false;
      this.StorageAllotDan.OutWarehouseID = e.id;
      this.getShelf('out');
      this.StorageAllotDan.OutWarehouseName = e.label;
      this.AllotNotes = [];
    },
    SetInWarehouse(e) {
      if (!e) {
        this.StorageAllotDan.InWarehouseID = "";
        return;
      }
      this.addType = false;
      this.StorageAllotDan.InWarehouseID = e.id;
      this.StorageAllotDan.InWarehouseName = e.label;
      // this.getShelf('in');
      this.changeDraft(e.label, 'InWarehouseName', 0)
    },
    append() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.ApproveState && this.AllotOpertion.Opertion != 'Update') {
            this.ApproveShow = true;
            return
          }
          let list = this.AllotNotes;
          if (list.length == 0) {
            msgTips(this.$t('StorageAllot.msgTips'));
            return;
          }
          if (this.StorageAllotDan.OutWarehouseID == this.StorageAllotDan.InWarehouseID) {
            msgTips(this.$t('StorageAllot.RoomMsgTips'));
            return;
          }
          // let arr = JSON.stringify(this.ApproveKeys);
          // let strlist = arr.map(val => {
          //   return val.join(',');
          // })
          let form = {
            OutWarehouseID: this.StorageAllotDan.OutWarehouseID,
            InWarehouseID: this.StorageAllotDan.InWarehouseID,
            OutAllotRemark: this.StorageAllotDan.OutAllotRemark,
            OutAllotTime: this.StorageAllotDan.OutAllotTime,
            GoodsDetail: "",
            ApprovalUser: JSON.stringify(this.ApproveKeys)
          };
          let str = [];
          for (let item of list) {
            let { GoodsID, HuoPinID, AllotCount, GoodsRemark, DefaultPrice } = item;
            str.push({
              GoodsID,
              HuoPinID,
              FactStock: AllotCount,
              GoodsRemark,
              AllPrice: parseFloat(AllotCount * DefaultPrice).toFixed(2),
            });
          }
          form.GoodsDetail = JSON.stringify(str);
          if (this.AllotOpertion.Opertion == 'Add') {
            addAllotDan(form).then((res) => {
              if (res.Code == 0) {
                successTips(res.Message);
                this.shows = false;
                this.value = "";
                window.localStorage.setItem(this.draftTitle[this.draftIndex], null);
                window.localStorage.setItem('StorageAllotNotes', null);
                this.draftState[this.draftIndex] = false;
                this.AllotNotes = [];
                this.$emit('message', res.Code);
                this.$store.commit("GET_COUNT", true);
                this.close();
              }
            });
          } else {
            updateAllotDan({
              AllotDanID: this.StorageAllotDan.AllotDanID,
              ...form,
            }).then((res) => {
              if (res.Code == 0) {
                successTips(res.Message);
                this.shows = false;
                this.value = "";
                window.localStorage.setItem(this.draftTitle[this.draftIndex], null);
                window.localStorage.setItem('StorageAllotNotes', null);
                this.draftState[this.draftIndex] = false;
                this.AllotNotes = [];
                this.$emit('message', res.Code);
                this.close();
              }
            });
          }
        }
      });
    },

    reset() {
      for (let i in this.StorageAllotDan) {
        this.StorageAllotDan[i] = "";
      }
      this.value = "";
      this.value1 = "";
      this.value2 = "";
      this.AllotNotes = [];
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row) {
      if (row.AllotStatus == 5 || row.AllotStatus == 6) {
        return;
      }
      this.$refs.tableList.toggleRowSelection(row); //设置复选框为选中状态
    },
    //点击背景色
    selectRowClassName({ row }) {
      var color = "";
      this.multipleSelection.forEach(item => {
        if (item.AllotDanID == row.AllotDanID) {
          color = "warning-row";
        }
      });
      return color;
    },

    handleRowClick1(row) {
      // this.$refs.dialogList.clearSelection();
      // let index = this.multipleSelection.findIndex(item => {
      //   // 判断已选数组中是否已存在该条数据
      //   return item.GoodsID == row.GoodsID
      // });
      // if (index == -1) {
      //   // 如果未存在，设置已选状态，并在list中添加这条数据
      //   this.$refs.dialogList.toggleRowSelection(row, true); //设置复选框为选中状态
      // } else {
      //   // 如果已存在，设置未选状态，并在list中删除这条数据
      //   this.$refs.dialogList.toggleRowSelection(row, false); //设置复选框为未选状态
      // }
      this.$refs.dialogList.toggleRowSelection(row); //设置复选框为选中状态
    },
    selectRowClassName1({ row }) {
      var color = "";
      this.multipleSelection1.forEach(item => {
        if (item.GoodsID == row.GoodsID) {
          color = "warning-row";
        }
      });
      return color;
    },
    handleSelectionChange1(val) {
      this.multipleSelection1 = val;
      if (val.length != 0) {
        this.goodsChecked = false;
        this.selectTable = val;
      } else {
        this.goodsChecked = true;
      }
      if (val.length == 1) {
        this.NotesID = val[0].GoodsID;
      }
    },
    // 删除货品
    DelGoods() {
      for (let i = 0; i < this.selectTable.length; i++) {
        let list = JSON.parse(JSON.stringify(this.AllotNotes));
        this.AllotNotes = list.filter((item) => item.GoodsID != this.selectTable[i].GoodsID);
        window.localStorage.setItem('StorageAllotNotes', JSON.stringify(this.AllotNotes));
      }
    },

    BatchInput(e) {
      let list = this.AllotNotes.map(item => {
        item.AllotCount = e;
        return item
      })
      this.AllotNotes = JSON.parse(JSON.stringify(list));
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form-item__error {
  padding-top: 42px !important;
}

.but_add {
  display: flex;
  justify-content: space-between;
  padding: 8px 0 0 0 !important;
}

.el-divider.el-divider--horizontal {
  margin-bottom: 20px;
}

.el-divider.el-divider--horizontal {
  margin-top: 55px;
}

::v-deep .el-button[data-v-f6961be4] {
  margin-right: 0px !important;
}

.el-divider--vertical {
  height: 2em;
  margin-left: 30px;
}

.dialog-footer {
  float: right;
}

form.el-form.el-form--label-left {
  margin-top: 24px;
}

.input-with-select.el-input.el-input-group.el-input-group--append {
  // max-width: 330px;
  width: calc(100% - 50px) !important;
}

._dialog {
  width: 100%;
  min-height: calc(100vh - 140px);
  // padding: 0 20px 20px;
  background-color: #fff;

  ._top {
    height: 48px;
    display: flex;
    align-items: center;

    span {
      color: #4e5969;
      font-size: 14px;
      margin: 0 20px 0 5px;
      cursor: pointer;
    }

    font {
      font-size: 16px;
      font-weight: bold;
      margin-left: 20px;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 160px;
      height: 160px;
    }

    span {
      line-height: 30px;
    }

    font {
      color: #5c90ff;
      cursor: pointer;
    }
  }

  ._footer {
    padding: 10px 0 0 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

._top {
  height: 48px;
  display: flex;
  align-items: center;

  span {
    color: #4e5969;
    font-size: 14px;
    margin: 0 20px 0 5px;
    cursor: pointer;
  }

  font {
    font-size: 16px;
    font-weight: bold;
    margin-left: 20px;
  }
}

.SearchName {
  margin-right: 0% !important;
}

.textarea {
  // width: 88.5% !important;
  width: calc(100% - 50px) !important;
}

.el-input {
  // width: 75% !important;
  // max-width: 330px;
  width: calc(100% - 50px) !important;
}

/deep/ .el-table__empty-block {
  width: 20%;
  min-width: 121%;
  max-width: 20%;
  padding-right: 20%;
}

.companyimg {
  line-height: 150px;
}

.el-icon-plus {
  border: 1px dashed;
  // background-color: #8c939d;
}

.el-link {
  margin-right: 30px;
}

//头像
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 15px;
  color: #8c939d;
  width: 135px;
  height: 128;
  line-height: 120px;
  text-align: center;
}

.el-input--mini .el-input__inne {
  height: 39px;
}

.avatar {
  width: 135px;
  height: 128;
  display: block;
}

//
.ul_but li {
  margin-bottom: 20px;
}

.ul_but:hover {
  cursor: pointer;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

._table_input {
  border-bottom: 1px solid #eee;
  width: calc(100% - 0px) !important;

  /deep/.el-input__inner {
    text-align: center;
  }
}

::v-deep ._table_input.el-input {
  padding: 0px !important;
}

.settin-box {
  width: 100%;
  height: calc(100vh - 20px);
  display: flex;
  background-color: #fff;
  border-radius: 5px;

  ul {
    padding: 0;
    margin: 0;
  }

  ._right {
    display: flex;
    flex: 1;
    position: relative;

    .content_left {
      height: calc(100vh - 70px);
      padding: 30px 10px;
      font-size: 19px;

      .tabs {
        display: flex;
        height: 50px;

        .tabs_item {
          display: block;
          padding: 10px;
          // line-height: 30px;

          &:hover {
            color: #409eff;
            cursor: pointer;
          }
        }
      }

      .content {
        padding: 20px 10px;

        span {
          font-size: 14px;
        }

        .title_box {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .el-icon-plus {
            color: #409eff;
            cursor: pointer;
          }
        }

        .title {
          font-size: 14px;
          font-weight: 550;
          display: block;
          margin-bottom: 20px;
        }

        ul li {
          font-size: 14px;
          display: flex;
          align-items: center;
          height: 40px;
          padding: 0 0 0 10px;
          border-radius: 20px;
          margin: 10px 0;

          // &:hover {
          //   background-color: #409eff;
          //   color: #fff;
          //   cursor: pointer;
          // }

          span {
            margin-left: 10px;
          }
        }
      }
    }

    .content_right {
      height: calc(100vh - 70px);
      position: absolute;
      width: 100%;
      right: 0;
      padding: 10px;

      .head_line {
        display: flex;
        align-items: center;
        height: 80px;

        .el-input {
          width: 200px !important;
        }

        .el-button {
          margin-left: 20px;
        }
      }

      .content_table {
        width: 100%;
        overflow: hidden;
        box-shadow: 0 0 5px rgb(201, 199, 199);
      }
    }
  }

  @media screen and (max-width: 1400px) {
    ._left {
      display: none;
    }
  }
}

._filter {
  height: 60px;
  justify-content: flex-end;
  align-items: center;
  width: 100%;

  span {
    margin-right: 20px;
    font-size: 14px;
    cursor: pointer;
    float: right;
    line-height: 45px;

    .el-icon-refresh {
      margin-left: 10px;
      font-size: 16px;
    }
  }
}

.check {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}

.listindex {
  color: #fff;
  background-color: #409eff;
}

._filter_btn {
  width: 100%;
  text-align: center;
  bottom: 100px;
  margin-top: 15%;

  .el-button {
    width: 100px;

    &:nth-child(2) {
      margin-left: 50px;
    }
  }
}

.el-icon-refresh {
  color: #409eff;
}

.filter_box {
  ul {
    padding-left: 10px;
  }

  li {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;

    .date {
      // margin-left: 45px;
      width: 300px;

      .el-input:nth-child(2) {
        margin-top: 10px;
      }

      /deep/.el-input {
        width: 300px !important;

        .el-input__inner {
          width: 300px !important;
        }
      }
    }
  }

  font {
    display: inline-block;
    width: 100px;
    font-size: 14px;
    color: #fff;
  }

  .el-select {
    width: 300px;
  }

  .el-input {
    width: 300px;
  }

  ._filter_btn {
    width: 100%;
    text-align: center;
    bottom: 100px;

    .el-button {
      width: 100px;

      &:nth-child(2) {
        margin-left: 50px;
      }
    }
  }
}

::v-deep .el-form-item>.el-form-item__label::before {
  content: "" !important;
  color: #000 !important;
}

::v-deep .el-form-item__label::after {
  content: "*";
  color: #ffffff;
  margin-left: 4px;
}

::v-deep .is-required .el-form-item__label::after {
  content: "*";
  color: #ff0000;
  margin-left: 4px;
}
</style>